import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";

const WHATSAPP_URL = "https://wa.me/5547992561262?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento.";

const VALUES = [
  { icon: "ri-shield-star-line", title: "Excelência Técnica", desc: "Aplicamos os mais altos padrões técnicos em cada projeto, garantindo qualidade e segurança." },
  { icon: "ri-hand-heart-line", title: "Compromisso", desc: "Comprometidos com a satisfação do cliente em cada etapa do processo." },
  { icon: "ri-lightbulb-line", title: "Inovação", desc: "Buscamos constantemente novas soluções e tecnologias para melhores resultados." },
  { icon: "ri-leaf-line", title: "Sustentabilidade", desc: "Projetos responsáveis com o meio ambiente, integrando práticas sustentáveis." },
];

const TEAM = [
  {
    name: "Engenheiro Responsável",
    role: "Engenheiro Civil",
    img: "https://readdy.ai/api/search-image?query=professional%20male%20civil%20engineer%20architect%20portrait%20corporate%20headshot%20confident%20expression%20suit%20professional%20background%20clean%20studio%20photography%20high%20quality&width=400&height=400&seq=team1&orientation=squarish",
  },
  {
    name: "Arquiteta Responsável",
    role: "Arquiteta & Urbanista",
    img: "https://readdy.ai/api/search-image?query=professional%20female%20architect%20designer%20portrait%20corporate%20headshot%20confident%20smile%20business%20attire%20clean%20studio%20background%20professional%20photography%20high%20quality&width=400&height=400&seq=team2&orientation=squarish",
  },
  {
    name: "Designer de Interiores",
    role: "Especialista em Interiores",
    img: "https://readdy.ai/api/search-image?query=professional%20female%20interior%20designer%20portrait%20corporate%20headshot%20friendly%20smile%20business%20professional%20clean%20studio%20background%20high%20quality%20photography&width=400&height=400&seq=team3&orientation=squarish",
  },
];

const TIMELINE = [
  { year: "2014", title: "Fundação", desc: "A Construlife nasceu com o propósito de oferecer engenharia de qualidade acessível." },
  { year: "2016", title: "Expansão de Serviços", desc: "Ampliamos nosso portfólio com design de interiores e maquetes 3D." },
  { year: "2019", title: "50 Projetos", desc: "Marco de 50 projetos entregues com excelência e clientes satisfeitos." },
  { year: "2021", title: "Regularização Especializada", desc: "Tornamo-nos referência em regularização de construções na região." },
  { year: "2024", title: "150+ Projetos", desc: "Consolidados como referência em engenharia e arquitetura na região." },
];

export default function Sobre() {
  return (
    <main>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-40 pb-24 overflow-hidden" style={{ backgroundColor: "#1E3A8A" }}>
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=geometric%20abstract%20architecture%20pattern%20blueprint%20technical%20drawing%20lines%20engineering%20design%20minimal%20pattern%20white%20on%20dark%20background&width=1920&height=600&seq=sobreHero&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <span className="text-[#C9A24A] text-xs font-semibold tracking-widest uppercase mb-4 block">Quem somos</span>
          <h1 className="text-white font-bold text-5xl md:text-6xl mb-5 leading-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Sobre a Construlife
          </h1>
          <div className="w-16 h-1 mx-auto bg-[#C9A24A] mb-6" />
          <p className="text-white/80 text-lg max-w-2xl mx-auto leading-relaxed">
            Conheça nossa história, valores e a equipe dedicada a transformar projetos em realidade com excelência e comprometimento.
          </p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20architects%20engineers%20office%20team%20working%20on%20blueprints%20architectural%20plans%20modern%20workspace%20collaborative%20environment%20contemporary%20office%20design%20professional%20setting%20high%20quality&width=800&height=580&seq=sobreImg1&orientation=landscape"
                  alt="Equipe Construlife"
                  className="w-full h-[450px] object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 -right-5 bg-[#1E3A8A] text-white p-6 rounded-xl text-center">
                <p className="font-bold text-4xl" style={{ fontFamily: "'Poppins', sans-serif", color: "#C9A24A" }}>10+</p>
                <p className="text-white/80 text-sm mt-1">Anos de experiência</p>
              </div>
            </div>
            <div>
              <span className="text-[#2563EB] text-xs font-semibold tracking-widest uppercase mb-3 block">Nossa história</span>
              <h2 className="text-[#1F1F1F] font-bold text-4xl mb-5 leading-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
                Uma empresa construída<br />sobre <span style={{ color: "#2563EB" }}>sólidas bases</span>
              </h2>
              <div className="w-16 h-1 bg-[#C9A24A] mb-6" />
              <p className="text-[#7A7A7A] text-[16px] leading-relaxed mb-4">
                A Construlife Engenharia e Arquitetura nasceu com uma missão clara: oferecer serviços técnicos de alta qualidade, com atendimento personalizado e comprometimento real com cada cliente.
              </p>
              <p className="text-[#7A7A7A] text-[16px] leading-relaxed mb-4">
                Ao longo de mais de 10 anos de atuação, construímos um portfólio diversificado que contempla projetos residenciais, comerciais e obras de regularização, sempre com foco na excelência técnica e na satisfação dos nossos clientes.
              </p>
              <p className="text-[#7A7A7A] text-[16px] leading-relaxed mb-8">
                Nossa equipe multidisciplinar reúne engenheiros, arquitetos e designers comprometidos em entregar soluções completas e inovadoras para cada necessidade.
              </p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#2563EB] hover:bg-[#1E3A8A] text-white font-semibold px-7 py-4 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line" />
                Falar Conosco
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24" style={{ backgroundColor: "#F8F9FA" }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <span className="text-[#2563EB] text-xs font-semibold tracking-widest uppercase mb-3 block">O que nos guia</span>
            <h2 className="text-[#1F1F1F] font-bold text-4xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Nossos Valores
            </h2>
            <div className="w-16 h-1 mx-auto bg-[#C9A24A]" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-7">
            {VALUES.map((v) => (
              <div key={v.title} className="bg-white rounded-xl p-7 text-center hover:scale-[1.02] transition-transform duration-300">
                <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-full" style={{ backgroundColor: "#2563EB15" }}>
                  <i className={`${v.icon} text-3xl`} style={{ color: "#2563EB" }} />
                </div>
                <h3 className="text-[#1F1F1F] font-bold text-xl mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>{v.title}</h3>
                <p className="text-[#7A7A7A] text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Numbers */}
      <section className="py-20" style={{ backgroundColor: "#1E3A8A" }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-0 divide-x divide-white/20">
            {[
              { v: "150+", l: "Projetos Realizados", i: "ri-building-2-line" },
              { v: "80+", l: "Obras Executadas", i: "ri-hammer-line" },
              { v: "120+", l: "Clientes Satisfeitos", i: "ri-user-star-line" },
              { v: "10+", l: "Anos de Mercado", i: "ri-calendar-check-line" },
            ].map((s) => (
              <div key={s.l} className="text-center py-10 px-6">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                  <i className={`${s.i} text-3xl`} style={{ color: "#C9A24A" }} />
                </div>
                <p className="text-white font-bold text-5xl mb-1" style={{ fontFamily: "'Poppins', sans-serif" }}>{s.v}</p>
                <p className="text-white/75 text-sm">{s.l}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-14">
            <span className="text-[#2563EB] text-xs font-semibold tracking-widest uppercase mb-3 block">Nossa trajetória</span>
            <h2 className="text-[#1F1F1F] font-bold text-4xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Nossa História
            </h2>
            <div className="w-16 h-1 mx-auto bg-[#C9A24A]" />
          </div>
          <div className="relative">
            <div className="absolute left-1/2 -translate-x-1/2 w-0.5 bg-[#E5E7EB] top-0 bottom-0 hidden md:block" />
            <div className="flex flex-col gap-8">
              {TIMELINE.map((item, i) => (
                <div key={item.year} className={`flex flex-col md:flex-row items-center gap-6 ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}>
                  <div className={`flex-1 ${i % 2 === 0 ? "md:text-right" : "md:text-left"}`}>
                    <div className="bg-white border border-[#E5E7EB] rounded-xl p-6 hover:border-[#2563EB] transition-colors">
                      <span className="text-[#C9A24A] font-bold text-sm block mb-2">{item.year}</span>
                      <h3 className="text-[#1F1F1F] font-bold text-xl mb-2" style={{ fontFamily: "'Poppins', sans-serif" }}>{item.title}</h3>
                      <p className="text-[#7A7A7A] text-sm">{item.desc}</p>
                    </div>
                  </div>
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-full z-10" style={{ backgroundColor: "#2563EB" }}>
                    <i className="ri-record-circle-line text-white text-xl" />
                  </div>
                  <div className="flex-1 hidden md:block" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-24" style={{ backgroundColor: "#F8F9FA" }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <span className="text-[#2563EB] text-xs font-semibold tracking-widest uppercase mb-3 block">Profissionais</span>
            <h2 className="text-[#1F1F1F] font-bold text-4xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Nossa Equipe
            </h2>
            <div className="w-16 h-1 mx-auto bg-[#C9A24A]" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {TEAM.map((m) => (
              <div key={m.name} className="bg-white rounded-2xl overflow-hidden text-center hover:scale-[1.02] transition-transform duration-300">
                <div className="h-56 overflow-hidden">
                  <img src={m.img} alt={m.name} className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-6">
                  <h3 className="text-[#1F1F1F] font-bold text-xl mb-1" style={{ fontFamily: "'Poppins', sans-serif" }}>{m.name}</h3>
                  <p className="text-[#2563EB] text-sm font-medium">{m.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ backgroundColor: "#1F1F1F" }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-white font-bold text-4xl mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Pronto para começar seu projeto?
          </h2>
          <p className="text-white/70 text-lg mb-8">Entre em contato com nossa equipe e receba uma consultoria personalizada.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-2 bg-[#C9A24A] hover:bg-[#b8902f] text-[#121212] font-bold px-8 py-4 rounded-lg transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-whatsapp-line" /> Falar no WhatsApp
            </a>
            <Link to="/servicos"
              className="flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-[#1F1F1F] font-semibold px-8 py-4 rounded-lg transition-all whitespace-nowrap cursor-pointer">
              Ver Serviços <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
